import {Component, OnInit, ViewChild, ElementRef} from '@angular/core';
import { ActivatedRoute } from '@angular/router';


import {ArchiveService} from '../../../services/archive.service';
import {Archive, Filter, FilterQuery} from '../../../services/archive.model';
import { ArchiveListComponent } from '../archive-list/archive-list.component';

@Component({
  selector: 'app-archive',
  templateUrl: './archive.component.html',
  styleUrls: ['./archive.component.scss']
})
export class ArchiveComponent implements OnInit {

  public archive: Archive = undefined;
  public filter: Filter = undefined;
  private filterQuery: FilterQuery;
  
  @ViewChild(ArchiveListComponent) archiveListComponent: ArchiveListComponent;
  @ViewChild('archiveContainer') archiveContainer: ElementRef;

  constructor(private archiveService: ArchiveService, private route: ActivatedRoute) {
    let params = this.route.snapshot.queryParams;
    this.archiveService.init(params);
    this.archiveService.archive.subscribe(archive => this.archive = archive);
    this.archiveService.filter.subscribe(filter => this.filter = filter);
    this.archiveService.activeFilter.subscribe(filter => {
      this.filterQuery = filter;
      this.scrollToTop();
    });
  }

  ngOnInit(): void {
  }
  
  scrollToTop() {
    setTimeout(() => {
      if (this.archiveListComponent && this.archiveListComponent.scrollContainer && window.innerWidth > 900) {
        // For desktop view, scroll the native scrollbar container
        this.archiveListComponent.scrollContainer.nativeElement.scrollTo({
          top: 0,
          behavior: "smooth",
        });
      } else if (window.innerWidth <= 900 && this.archiveContainer) {
        // For mobile view, scroll to the archive container
        this.archiveContainer.nativeElement.scrollIntoView({
          behavior: "smooth",
          block: "start"
        });
      }
    }, 100);
  }

}
